import React from 'react';
import PropTypes from 'prop-types';

const ReportFlag = ({ color = '#00ADEF', width = 24, height = 30, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M.6 1.2v27.6V1.2Zm22.8 3.228S13.2 7.2 13.2 3.6C13.2 0 3 3.6 3 3.6V18s10.2-3.6 10.2 0 10.2.888 10.2.888V4.428Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ReportFlag.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default ReportFlag;
